import { createSlice } from "@reduxjs/toolkit";
import { BaseApiState } from "../../../api/axiosConfig";
import { handlePending, handleReject } from "../../../utils/redux";
import {
  downloadDiagnosticReport,
  downloadDiagnosticChartsReport,
} from "../../actions/documentation/reportActions";

const initialDiagnosticReportState: BaseApiState = {
  succeeded: false,
  loading: false,
  error: false,
  errorMessage: undefined,
  errorDetails: undefined,
};

const DiagnosticReportSlice = createSlice({
  name: "documentation/reports/diagnostic",
  initialState: initialDiagnosticReportState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadDiagnosticReport.pending, handlePending)
      .addCase(downloadDiagnosticReport.rejected, handleReject)
      .addCase(downloadDiagnosticReport.fulfilled, (state) => {
        state.loading = false;
        state.succeeded = true;
      });
  },
});

const DiagnosticChartsReportSlice = createSlice({
  name: "documentation/reports/diagnosticCharts",
  initialState: initialDiagnosticReportState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadDiagnosticChartsReport.pending, handlePending)
      .addCase(downloadDiagnosticChartsReport.rejected, handleReject)
      .addCase(downloadDiagnosticChartsReport.fulfilled, (state) => {
        state.loading = false;
        state.succeeded = true;
      });
  },
});

export const DiagnosticReportReducer = DiagnosticReportSlice.reducer;
export const DiagnosticChartsReportReducer =
  DiagnosticChartsReportSlice.reducer;